

export const orderStatusIds ={
    success : 1,
    error : 2,
    wait :3
}

export const transactionTypes ={
    order : 1,
    refund : 2,
    cancel :3,
}